import { NgModule } from '@angular/core';

import { SharedModule } from '../../shared';
import { IntegrationNaturezaVendaSharedModule } from '../configuracoes/integration/natureza-venda';
import { NaturezaVendaRoutingModule } from './natureza-venda-routing.module';
import { NaturezaVendaSituacaoModule } from './situacao';

import { NaturezaVendaComponent } from './natureza-venda.component';
import { NaturezaVendaFormComponent} from './form';

@NgModule({
    imports: [
        SharedModule,
        NaturezaVendaRoutingModule,
        IntegrationNaturezaVendaSharedModule,
        NaturezaVendaSituacaoModule
    ],
    declarations: [
        NaturezaVendaComponent,
        NaturezaVendaFormComponent
    ]
})
export class NaturezaVendaModule { }
